import { GzAntimalwareOnExecuteWebComponent } from './component/GzAntimalwareOnExecuteWebComponent';

export { GzAntimalwareOnExecuteWebComponent };
